var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-content"},[_c('img',{attrs:{"src":"/image/no-search-data.svg"}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.content || _vm.$t('common.emptyDefaultTxt')))])])}
var staticRenderFns = []

export { render, staticRenderFns }